import { data } from '../../svg/Delete/data';
import { makeIcon } from '../makeIcon';

export const Delete = makeIcon(data, 'delete', 'Delete');

export default Delete;
